import axiosInstance from '@/plugins/api/axiosInstance';
import generateQueryParams from '@/utils/generateQueryParams';

export default function carrier() {
    return {
        index,
        get,
        create,
        update,
        remove
    };

    function index(options = {}) {
        const defaultValues = {
            pattern: '',
            limit: 25,
            page: 1
        };
        const params = generateQueryParams(options, defaultValues);
        return axiosInstance.get(`carrier/search${params}`);
    }

    function get(id) {
        return axiosInstance.get(`carrier/get?id=${id}`);
    }

    function create(data) {
        return axiosInstance.post('carrier/create', data);
    }

    function update(data) {
        return axiosInstance.patch(`carrier/update`, data);
    }

    function remove(id) {
        return axiosInstance.delete(`carrier/delete`, {
            data: {
                id: id
            }
        });
    }
}
